import { transitionalStatuses } from "@/config";

interface ServerStateSnapshot {
  status: string;
  queuePosition?: number | null;
  billingSettlementPending?: boolean;
}

export type ServerAction = "start" | "restart" | "stop" | "kill";

export function serverActionAvailability(
  server: ServerStateSnapshot,
): Record<ServerAction, boolean> {
  const stopped = server.status === "stopped";
  const failed = server.status === "failed";
  const running = server.status === "running";
  const billingPending = isBillingSettlementPending(server);
  return {
    start: (stopped || failed) && !billingPending,
    restart: running && !billingPending,
    stop: running,
    kill: !stopped,
  };
}

export function isBillingSettlementPending(server: ServerStateSnapshot): boolean {
  return server.billingSettlementPending === true && ["stopped", "failed"].includes(server.status);
}

export function serverStatePolicy(server: ServerStateSnapshot) {
  const pending = transitionalStatuses.has(server.status);
  const failed = server.status === "failed";
  const canAct =
    !isBillingSettlementPending(server) &&
    ["stopped", "starting", "running"].includes(server.status);
  const setupStage =
    server.status === "queued_install"
      ? 0
      : server.status === "installing"
        ? 1
        : ["queued_start", "starting"].includes(server.status)
          ? 2
          : -1;

  return { pending, failed, canAct, setupStage };
}
